document.addEventListener("DOMContentLoaded", function () {
    const menuToggle = document.querySelector(
        ".wp-block-neodigital-search-toggle__button",
    );
    if (menuToggle) {
        menuToggle.addEventListener("click", function () {
            document.body.classList.toggle("search--open");
        });
    }
});
